import React, { useState, useRef } from "react"

import Icon from "icons"
import useAccordion from "./useAccordionTransition"

import { Container, Summary, IconContainer } from "./styles"

const AccordionItem = ({ className, title, content, children, isArticleFAQ }) => {
  const containerRef = useRef(null)
  const summaryRef = useRef(null)
  const bodyRef = useRef(null)

  const accordion = useAccordion(containerRef, summaryRef, bodyRef)

  const [isExpanded, setExpanded] = useState(false)

  const handleExpand = (event) => {
    event.preventDefault()

    accordion.onClick()
    setExpanded((prevIsExpanded) => !prevIsExpanded)
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter" || event.key === "Space") {
      handleExpand()
    }
  }

  return (
    <Container className={className} ref={containerRef} isArticleFAQ={isArticleFAQ}>
      <Summary ref={summaryRef} isArticleFAQ={isArticleFAQ} onClick={handleExpand}>
        {typeof title === "string" ? <h3 dangerouslySetInnerHTML={{ __html: title }} /> : title}
        <IconContainer onKeyDown={handleKeyPress}>
          {isExpanded ? <Icon id="minus" width={14} height={14} /> : <Icon id="plus" width={14} height={14} />}
        </IconContainer>
      </Summary>
      {content ? (
        <div ref={bodyRef} dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <div ref={bodyRef}>{children}</div>
      )}
    </Container>
  )
}

export default AccordionItem
